import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#F7F7F7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
      paddingTop: theme.spacing(6),
    },
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  logo: {
    height: 64,
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: 52,
    },
  },
  taglineDivider: {
    width: 1,
    height: 40,
    backgroundColor: '#D8D8D8',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      height: 32,
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
    },
  },
  tagline: {
    fontFamily: '"Frank Ruhl Libre", serif',
    fontSize: 20,
    color: '#00234B',
    fontWeight: 800,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  card: {
    maxWidth: 440,
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: theme.spacing(5),
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      maxWidth: 400,
    },
  },
  title: {
    fontWeight: 700,
    fontSize: 28,
    color: '#00234B',
    marginBottom: theme.spacing(1),
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  description: {
    color: '#555555',
    fontSize: 14,
    lineHeight: 1.6,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  sectionLabel: {
    fontWeight: 600,
    fontSize: 12,
    color: '#555555',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: theme.spacing(1),
  },
  emailVerificationBox: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E0E0E0',
    borderRadius: 4,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(3),
  },
  emailAvatar: {
    width: 32,
    height: 32,
    backgroundColor: '#E8EEF5',
    color: '#00234B',
    marginRight: theme.spacing(1.5),
  },
  emailText: {
    flex: 1,
    fontSize: 14,
    color: '#333333',
  },
  verifiedIcon: {
    color: '#4CAF50',
    fontSize: 24,
  },
  pendingIcon: {
    color: '#FF9800',
    fontSize: 24,
  },
  consentSection: {
    marginBottom: theme.spacing(3),
  },
  consentBox: {
    backgroundColor: '#F9F9F9',
    borderRadius: 4,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  consentCheckbox: {
    alignItems: 'flex-start',
    marginLeft: 0,
    marginRight: 0,
  },
  checkbox: {
    padding: theme.spacing(0, 1, 0, 0),
    color: '#9E9E9E',
    '&.Mui-checked': {
      color: '#00234B',
    },
  },
  consentLabelContainer: {
    marginTop: -2,
  },
  consentTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
    marginBottom: 4,
  },
  consentText: {
    fontSize: 13,
    color: '#666666',
    lineHeight: 1.5,
  },
  consentLink: {
    color: '#3268A7',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  submitButton: {
    backgroundColor: '#00234B',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'uppercase',
    letterSpacing: 1,
    padding: theme.spacing(1.5),
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#001834',
    },
    '&:disabled': {
      backgroundColor: '#9E9E9E',
      color: '#FFFFFF',
    },
  },
  verifyButton: {
    backgroundColor: '#3268A7',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'uppercase',
    letterSpacing: 1,
    padding: theme.spacing(1.5),
    borderRadius: 4,
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#285a8f',
    },
    '&:disabled': {
      backgroundColor: '#9E9E9E',
      color: '#FFFFFF',
    },
  },
  helpLink: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    fontSize: 14,
    color: '#555555',
  },
  supportLink: {
    color: '#3268A7',
    fontWeight: 600,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  footer: {
    marginTop: 'auto',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    color: '#9E9E9E',
    fontSize: 12,
  },
  successMessage: {
    textAlign: 'center',
  },
  successIcon: {
    color: '#4CAF50',
    fontSize: 48,
    marginBottom: theme.spacing(2),
  },
  successTitle: {
    fontWeight: 700,
    fontSize: 24,
    color: '#00234B',
    marginBottom: theme.spacing(2),
  },
  successDescription: {
    color: '#555555',
    fontSize: 14,
    lineHeight: 1.6,
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: '#555555',
    fontSize: 14,
  },
  errorContainer: {
    textAlign: 'center',
    padding: theme.spacing(2),
  },
  errorIcon: {
    color: '#F44336',
    fontSize: 48,
    marginBottom: theme.spacing(2),
  },
  errorTitle: {
    fontWeight: 700,
    fontSize: 24,
    color: '#00234B',
    marginBottom: theme.spacing(2),
  },
  errorDescription: {
    color: '#555555',
    fontSize: 14,
    lineHeight: 1.6,
    marginBottom: theme.spacing(3),
  },
  errorButton: {
    backgroundColor: '#00234B',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'uppercase',
    letterSpacing: 1,
    padding: theme.spacing(1.5, 4),
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#001834',
    },
  },
  requiredAsterisk: {
    color: '#F44336',
    marginLeft: 2,
  },
  validationError: {
    color: '#F44336',
    fontSize: 12,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  // Email input styles for QR flow
  emailInputSection: {
    marginBottom: theme.spacing(3),
  },
  emailInputLabel: {
    fontWeight: 600,
    fontSize: 12,
    color: '#555555',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: theme.spacing(1),
  },
  emailTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#00234B',
      },
    },
  },
  emailIcon: {
    color: '#9E9E9E',
  },
  // OTP verification section
  otpSection: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  otpDescription: {
    color: '#555555',
    fontSize: 14,
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  },
  // Achievement preview card
  achievementPreview: {
    backgroundColor: '#F9F9F9',
    borderRadius: 8,
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(3),
    border: '1px solid #E0E0E0',
  },
  achievementPreviewTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: '#00234B',
    marginBottom: theme.spacing(1.5),
  },
  achievementPreviewGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
    },
  },
  achievementPreviewItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  achievementPreviewLabel: {
    fontSize: 11,
    color: '#9E9E9E',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 2,
  },
  achievementPreviewValue: {
    fontSize: 14,
    color: '#333333',
    fontWeight: 500,
  },
  // Divider
  sectionDivider: {
    height: 1,
    backgroundColor: '#E0E0E0',
    margin: theme.spacing(3, 0),
  },
}))

export default useStyles
